import axios from "axios";

const formatearNIC = NIC => {
  NIC = NIC.toLowerCase(NIC);
  if (isValidURL(NIC) || isSubdomain(NIC)) {
    return NIC;
  } else if (isAlphanumeric(NIC)) {
    return "http://" + NIC + ".caldenoil.com";
  } else {
    if (NIC.match(/:/g).length === 1) {
      var tokens = NIC.split(":");
      return "http://" + tokens[0] + ".caldenoil.com:" + tokens[1];
    } else {
      return "http://" + NIC + ".caldenoil.com";
    }
  }
};

const VENDEDORES_HARDCODED_YPF = {
  idEmpleado: 102,
  token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySWQiOiJiZTYzYTY1Yy0wNTU1LTQ3MGEtYjlmMy1kMDA3YjQ2ZGVmNmQiLCJVc2VyTmFtZSI6IkFETUlOIiwiVXNlckxvZ2luIjoiQURNSU4iLCJFeHBpcmF0aW9uRGF0ZVRpbWUiOiJcL0RhdGUoMTc4MzE2NzI3MjE2MClcLyJ9.moFjVDBxzP6zC5WPqjJk4SaEeBmsjzfoBkhaUKZUBoM",
  nombre: "ADMIN",
  listaPrecioPorCliente: false,
  razonSocialEstacion: "BERAZA Y CIA SRL",

  salesman_PermiteModificarPrecio: false,
  idGrupoVendedores: null,
};

const validarUsuario = async userData => {
  try {
    // Simular una respuesta exitosa con la estructura esperada
    return {
      status: 200,
      data: VENDEDORES_HARDCODED_YPF,
    };
  } catch (error) {
    throw error;
  }
};

const isValidURL = s => {
  var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return regexp.test(s);
};

const isSubdomain = url => {
  var regex = new RegExp(/^([a-z]+:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
  return !!url.match(regex);
};

const isAlphanumeric = str => {
  var regex = new RegExp(/^[a-z0-9]+$/i);
  return !!str.match(regex);
};

const conexion = {
  formatearNIC,
  validarUsuario,
};

export default conexion;
